const config = {
  development: {
    appDomain: 'http://127.0.0.1:3004',
    baseurl: 'http://127.0.0.1:3003',
    knowledgebase_spaces_ids: ['ESD', 'SLQ'],
    knowledgebase_default_space_id: ['ESD'],
  },
  staging: {
    baseurl: 'https://stagingapi.ed.peoplejoy.com',
    appDomain: 'https://appstaging.peoplejoy.com',
    knowledgebase_spaces_ids: ['ESD', 'SLQ'],
    knowledgebase_default_space_id: ['ESD'],
  },
  production: {
    appDomain:'https://app.peoplejoy.com',
    baseurl: 'https://internal.api.ed.peoplejoy.com',
    knowledgebase_spaces_ids: ['ESD', 'SLQ'],
    knowledgebase_default_space_id: ['ESD'],
  }
}

export default config[process.env.REACT_APP_ENV || "development"];
